import { Optional } from '@pogokid/util'
import { ProcessedEvent } from '../types.ts'
import { isSameDay } from 'date-fns'
import {
  eventStartTimeComparator,
  isEventOnDays,
  isMultiDayEvent,
} from './events.ts'

/**
 * Returns a sorted array of events which start
 * and end on the same day
 */
export function filterSingleDayEventsByDay(
  date: Date,
  events: Optional<ProcessedEvent[]>
): ProcessedEvent[] {
  return events
    ? events
        .filter(
          (e) => isSameDay(date, e.start) && !isMultiDayEvent(e)
        )
        .sort(eventStartTimeComparator)
    : []
}

/**
 * Returns all events which are multiday
 * and are within one of the daysList
 */
export function filterMultiDayEventsOnDays(
  daysList: Date[],
  events: ProcessedEvent[]
) {
  return events.filter(
    (e) => isMultiDayEvent(e) && isEventOnDays(daysList, e)
  )
}

export function filterEventsWithinDays(
  events: ProcessedEvent[],
  daysList: Date[]
) {
  return events.filter((e) => isEventOnDays(daysList, e))
}
